import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const validationSchema = Yup.object().shape({
  supplier: Yup.object().nullable().required('Supplier Name is Required'),
  customerSONumber: Yup.string().nullable(),
  // purchaseOrderTicketId: Yup.number().nullable().positive().integer(),
  purchaseOrderLocationId: Yup.string().nullable(),
  order: Yup.object().shape({
    effectiveDate: Yup.date().nullable(),
    expirationDate: Yup.date()
      .nullable()
      .when('effectiveDate', (effectiveDate, schema) => {
        if (effectiveDate) {
          return Yup.date()
            .min(effectiveDate, 'Expiration Date can not earlier than Effective Date')
            .typeError('Expiration Date is required')
        }
        return schema
      }),
    packageType: Yup.string().nullable(),
    pickupDelivery: Yup.string().nullable(),
    receivingYard: Yup.string().nullable(),
  }),
  currency: Yup.string().nullable(),
  paymentTermId: Yup.string().nullable(),
  paymentMethod: Yup.string().nullable(),
  paymentOptions: Yup.string().nullable(),
  notes: Yup.string().nullable(),
  docs: Yup.array().of(
    Yup.object().shape({
      createdAt: Yup.string().nullable(),
      name: Yup.string().nullable(),
      url: Yup.string().nullable(),
      uuid: Yup.string().nullable(),
    }),
  ),
  uploadcareGroupId: Yup.string().nullable(),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
